<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="4"
      >
        <view-card />
        <preview-card card-title="Gelir İşlemi Ön İzlemesi" />
      </b-col>
      <b-col
        cols="12"
        md="8"
      >
        <lines-card />
        <validation-observer
          v-if="dataItem.balance_amount > 0"
          ref="simpleRules"
        >
          <line-form />
          <save-button
            v-if="dataItem.is_return"
            btn-variant="danger"
            :save-action="submitReturnForm"
            :is-disabled="submitStatus"
            btn-label="Çek İade Edildi"
          />
          <save-button
            v-else
            :save-action="submitForm"
            :is-disabled="submitStatus"
          />
        </validation-observer>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import { BRow, BCol } from 'bootstrap-vue'
import ViewCard from '@/views/Admin/Promissories/View/ViewCard.vue'
import LinesCard from '@/views/Admin/Promissories/View/LinesCard.vue'
import LineForm from '@/views/Admin/Promissories/View/LineForm.vue'
import PreviewCard from '@/views/Admin/Account_activities/Incomes/PreviewCard.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import toastMixin from '@/libs/toast'

export default {
  name: 'Add',
  components: {
    BRow,
    BCol,
    ViewCard,
    LinesCard,
    LineForm,
    PreviewCard,
    SaveButton,
    ValidationObserver,
  },
  mixins: [toastMixin],
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    incomeDataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
    dataItem() {
      return this.$store.getters['promissories/dataItem']
    },
    saveData() {
      return this.$store.getters['accountActivities/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({ template: 'saveSuccess' })
      } else if (val.status === false) {
        this.showToast({ template: 'saveError' })
      }
    },
  },
  created() {
    this.getData()
    localize('tr')
  },
  methods: {
    getData() {
      this.$store.dispatch('promissories/getDataItem', this.$route.params.id)
    },
    submitReturnForm() {
      this.$store.dispatch('promissories/saveData', this.dataItem)
        .then(response => {
          if (response) {
            this.$router.push('/app/promissories')
          }
        })
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.incomeDataItem.id_promissories = this.$route.params.id
          this.$store.dispatch('accountActivities/saveData', this.incomeDataItem)
            .then(response => {
              if (response) {
                this.getData()
                this.$store.commit('accountActivities/RESET_DATA_ITEM')
                this.submitStatus = false
              }
            })
        } else {
          this.showToast({ template: 'requireWarning' })
        }
      })
    },
  },
}
</script>
